import AWS from "aws-sdk";
import { useAtom } from "jotai";
import React from "react";
import { MenuItem } from "../components/Menu";
import { currentSpaceAtom } from "../jotai/atoms";
import { useSpaceInfo } from "../roomservice/maps";
import { albumBucketName, AWSConfig } from "../utils/fileUpload";

function uploadHTML(blob: string, name: string) {
  AWS.config.update(AWSConfig);
  return new AWS.S3.ManagedUpload({
    params: {
      Bucket: albumBucketName,
      Key: "pages/" + name + ".html",
      Body: blob,
      ContentType: "text/html",
      ACL: "public-read",
    },
  }).promise();
}

async function digestMessage(message: string) {
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(""); // convert bytes to hex string
  return hashHex;
}

export default function ExportWebpage() {
  const [info] = useSpaceInfo();
  const [currentSpace] = useAtom(currentSpaceAtom);

  let exportPage = async () => {
    let stiches_styles = Array.from(document.styleSheets)
      .map((s) => {
        try {
          return Array.from(s.rules)
            .map((r) => r.cssText)
            .join("\n");
        } finally {
          return [];
        }
      })
      .join("\n");

    const style_overrides = `
      nav {display:none !important;}
      .minimap {display:none !important;}
      main, .background {cursor:pointer !important;}
      radix-portal { display: none; }
      .cursor { display: none; }
      `;
    const style_node = document.createElement("style");
    style_node.innerHTML = style_overrides + stiches_styles;

    document.head.appendChild(style_node);

    let HTML = (document?.body?.parentNode as Element).outerHTML;
    style_node.remove();

    // disable javascript (not the best way, should use cheerio to parse html)
    HTML = HTML.replace(/<script/g, "<noscript");
    HTML = HTML.replace(/\/script>/g, "/noscript>");

    const blob = new Blob([HTML], { type: "text/html" });

    // scrub real space id from the html
    const regex = new RegExp(currentSpace!.id, "g");
    const scrubbedHTMLstring = (await blob.text()).replace(regex, "[id]");

    // protect space id in URL by hashing
    const hashedId = await digestMessage(currentSpace!.id);
    const filename = `${(info?.name || "") + hashedId}`;

    const tab = window.open("about:blank");
    uploadHTML(scrubbedHTMLstring, filename).then((data) => {
      tab!.location = (data.Location as unknown) as Location;
      tab?.focus();
    });
  };
  return (
    <MenuItem
      onSelect={() => {
        // let menu finish closing before we snapshot
        window.setTimeout(exportPage, 10);
      }}
    >
      Publish space to webpage
    </MenuItem>
  );
}
